import Link from 'next/link'
import { withI18next } from '../../lib/withI18next'
import { getS3PdfWithLocale } from '../../lib/helpers'

const Sidebar = ({ t, i18n }) => (
  <div className="menu ma-sidebar">
    <div>
      <p className="menu-label">{t('common:sidebar_related-content')}</p>
      <ul className="menu-list">
        <li><a href="http://www.mazda.com/" target="_blank">{t('common:sidebar_mazda-corp')}</a></li>
        <li><a href="http://www.mazdausa.com/" target="_blank">{t('common:sidebar_mazda-usa')}</a></li>
        <li><a href="https://www.mazda.ca/" target="_blank">{t('common:sidebar_mazda-canada')}</a></li>
        <li><a href="https://s3.amazonaws.com/tsd.mazdausa.com/MazdaServiceInfo/Mazda_Position_Statements.pdf" target="_blank">{t('common:sidebar-item-15')}</a></li>
        <li><Link href="/special-tools"><a>{t('common:sidebar_special-tools-information')}</a></Link></li>
        <li>
          <a href="https://www.motorcraftservice.com/AsBuilt" target="_blank">{t('common:sidebar-item-2')}</a>
          <div className="pcm-note">
            <p className="pcm-note-text">{t('common:sidebar-item-6')} {t('common:sidebar-item-7')}</p>
          </div>
        </li>
        <li><a href="https://www6.b2b.mazda.co.jp/asbuilt2/" target="_blank">{t('common:sidebar-item-1')}</a></li>
        <li className="pcm-note">
          <p className="pcm-note-text">{t('common:sidebar-pcm-note')}</p>
        </li>
        <li><a href="https://s3.amazonaws.com/tsd.mazdausa.com/MazdaServiceInfo/Mazda_Vehicle_Handling/Mazda_Vehicle_Handling_Info.pdf" target="_blank">{t('common:sidebar-item-5')}</a></li>
        <li><a href="https://s3.amazonaws.com/tsd.mazdausa.com/MazdaServiceInfo/Seatbelt_Instructions/Seatbelt_Parts_List_Installation_Instructions.pdf" target="_blank">{t('common:sidebar-item-11')}</a></li>
      </ul>
    </div>
    <div>
      <p className="menu-label">{t('common:sidebar-label-1')}</p>
      <ul className="menu-list">
        <li><a href="https://mazda.locksmithsdrm.com/" target="_blank">{t('common:sidebar-item-3')}</a></li>
      </ul>
    </div>
    <div>
      <p className="menu-label-red">{t('common:sidebar-label-2')}</p>      
      <ul className="menu-list">
        <li>
          <a href={getS3PdfWithLocale('High_Voltage_Manuals', i18n.language)} target="_blank" >
            EMERGENCY RESCUE & RESPONSE GUIDES / HIGH VOLTAGE BATTERY HANDLING / CAPACITOR DISPOSAL MANUAL
          </a>
        </li>
      </ul>
      
      
    </div>
    
  </div>
)

export default withI18next(['common'])(Sidebar)



// WEBPACK FOOTER //
// ./components/Sidebar/index.js